// extracted by mini-css-extract-plugin
module.exports = {"main":"_3l8mdQh1Wl"};